<template>
    <div class="relative bg-gray-900">
        <div class="relative h-56 bg-indigo-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">
            <img class="h-full w-full object-cover"
                 src="/img/payLater.jpg"
                 alt="">
            <div aria-hidden="true"
                 class="absolute inset-0 bg-gradient-to-r from-teal-500 to-cyan-600 mix-blend-multiply"></div>
        </div>
        <div class="relative mx-auto max-w-md px-4 py-12 sm:max-w-7xl sm:px-6 sm:py-20 md:py-28 lg:px-8 lg:py-32">
            <div class="md:ml-auto md:w-1/2 md:pl-10">
                <h2 class="text-lg font-semibold text-gray-300">Zapłać za zakupy później</h2>
                <p class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">Jak to działa?</p>
                <p class="mt-3 text-lg text-gray-300">

                <p>Robisz zakupy w sklepie internetowym: <a href="https://uchowanca.pl/placepozniejesklep"
                                                            class="font-bold">sklep.uchowanca.pl</a>
                </p>
                <p class="mt-2">
                    W koszyku wybierasz metodę płatności: <span class="text-indigo-400">"Kupuję z iMoje"</span>, a w
                    bramce płatności opcję: <span class="text-indigo-400">"iMoje płacę później"</span>.
                    <br>
                <p class="mt-2">Dostępne są dwie platformy płatności odroczonych: <b>PayPo</b> i <b>Twisto</b>.</p>
                </p>

                </p>

                <div class="mt-8">
                    <div class="inline-flex rounded-md shadow">
                        <a href="https://uchowanca.pl/placepozniejesklep"
                           class="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-gray-900 hover:bg-gray-50">
                            Odwiedź sklep internetowy
                            <svg class="-mr-1 ml-3 h-5 w-5 text-gray-400"
                                 x-description="Heroicon name: mini/arrow-top-right-on-square"
                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                 aria-hidden="true">
                                <path fill-rule="evenodd"
                                      d="M4.25 5.5a.75.75 0 00-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 00.75-.75v-4a.75.75 0 011.5 0v4A2.25 2.25 0 0112.75 17h-8.5A2.25 2.25 0 012 14.75v-8.5A2.25 2.25 0 014.25 4h5a.75.75 0 010 1.5h-5z"
                                      clip-rule="evenodd"></path>
                                <path fill-rule="evenodd"
                                      d="M6.194 12.753a.75.75 0 001.06.053L16.5 4.44v2.81a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h2.553l-9.056 8.194a.75.75 0 00-.053 1.06z"
                                      clip-rule="evenodd"></path>
                            </svg>
                        </a>
                        <a href="https://uchowanca.pl"
                           class="ml-2 inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-gray-900 hover:bg-gray-50">
                            Zobacz promocje
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <!-- This example requires Tailwind CSS v2.0+ -->
    <div class="bg-white">
        <div class="mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:grid lg:grid-cols-3 lg:gap-x-8 lg:py-24 lg:px-8">
            <div>
                <h2 class="text-lg font-semibold text-indigo-600">Kup teraz, zapłać za 30 dni</h2>
                <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900">Platforma PayPo</p>
                <p class="mt-4 text-lg text-gray-500">Szczegółowe informacje znajdziesz na stronie: <a
                    href="https://paypo.pl" class="font-bold">paypo.pl</a></p>

                <a href="https://paypo.pl/?_gl=1*u3zvbs*_ga*MTIyOTY5OTY0OC4xNjYzNjE5NTEw*_ga_MEM1K577BX*MTY2MzYxOTUxMC4xLjAuMTY2MzYxOTUxMC42MC4wLjA.&amp;_ga=2.174108385.2505.1663619510-1229699648.1663619510">
                    <svg class="h-16 m-12 flex justify-center" viewBox="0 0 1023 281" fill="none">
                        <g clip-path="url(#clip99)">
                            <path d="M140.3 159.1H80.3V218.6H140.3V159.1Z" fill="#A70584"></path>
                            <path d="M140 78.4H80V138.4H140V78.4Z" fill="#36B587"></path>
                            <path d="M60 158.4H0V218.4H60V158.4Z" fill="#FAD05B"></path>
                            <path
                                d="M319.1 74.6C319.1 116 285.8 149.2 242.9 149.2H210.2V217.6H160.4V0H242.8C285.9 0 319.1 33.3 319.1 74.6ZM269.4 74.6C269.4 58.7 258.2 46.6 243 46.6H210.3V102.6H243C258.2 102.6 269.4 90.5 269.4 74.6Z"
                                fill="black"></path>
                            <path
                                d="M492.7 58V217.6H444.8V202.6C434.3 214.7 418.6 222.1 397.2 222.1C355.4 222.1 320.9 185.4 320.9 137.8C320.9 90.2 355.4 53.5 397.2 53.5C418.6 53.5 434.2 60.8 444.8 73V58H492.7ZM444.8 137.8C444.8 113.9 428.8 98.9 406.8 98.9C384.8 98.9 368.8 113.9 368.8 137.8C368.8 161.7 384.8 176.8 406.8 176.8C428.8 176.8 444.8 161.7 444.8 137.8Z"
                                fill="black"></path>
                            <path
                                d="M674.6 58L620.4 211.8C602.6 262.2 574.4 282.2 530 280V235.6C552.2 235.6 562.7 228.6 569.6 209.3L506.6 58H558.9L594.1 155L624 58H674.6Z"
                                fill="black"></path>
                            <path
                                d="M851.9 74.6C851.9 116 818.6 149.2 775.7 149.2H743V217.6H693.2V0H775.6C818.6 0 851.9 33.3 851.9 74.6ZM802.2 74.6C802.2 58.7 791 46.6 775.8 46.6H743.1V102.6H775.8C791 102.6 802.2 90.5 802.2 74.6Z"
                                fill="black"></path>
                            <path
                                d="M858.2 140C858.2 93.7 894.9 57.9 940.6 57.9C986.3 57.9 1023 93.6 1023 140C1023 186.4 986.3 222.1 940.6 222.1C894.9 222.1 858.2 186.3 858.2 140ZM976.3 140C976.3 117.9 960.8 103.3 940.5 103.3C920.3 103.3 904.7 117.9 904.7 140C904.7 162.1 920.2 176.7 940.5 176.7C960.8 176.7 976.3 162 976.3 140Z"
                                fill="black"></path>
                        </g>
                        <defs>
                            <clipPath id="clip99">
                                <rect width="1023" height="280.1" fill="white"></rect>
                            </clipPath>
                        </defs>
                    </svg>
                </a>

            </div>


            <div class="mt-12 lg:col-span-2 lg:mt-0">
                <dl class="space-y-10 sm:grid sm:grid-flow-col sm:grid-cols-2 sm:grid-rows-4 sm:gap-x-6 sm:gap-y-10 sm:space-y-0 lg:gap-x-8">
                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Termin zapłaty</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Masz aż 30 dni na zapłatę - bez dodatkowych
                            kosztów.
                        </dd>
                    </div>

                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Wygodne raty</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Jeśli potrzebujesz więcej czasu i swobody - możesz
                            rozłożyć płatność na wygodne raty.
                        </dd>
                    </div>

                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Obsługa zwrotów</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Sprawdzasz produkty w domu - nieudane zakupy
                            odsyłasz, płacisz tylko za te, które zatrzymasz.
                        </dd>
                    </div>

                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Zaszalej na zakupach</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Możesz pozwolić sobie na więcej - zrobić prezent
                            sobie lub bliskim albo zaszaleć na wyprzedaży
                        </dd>
                    </div>

                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Ochrona Kupującego</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Kupujesz bezpiecznie - płacisz tylko wtedy, kiedy
                            otrzymasz przesyłkę - chroni Cię Gwarancja Ochrony Kupującego
                        </dd>
                    </div>

                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Bezpieczeństwo</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Płatność PayPo zabezpiecza Cię lepiej i taniej niż
                            przesyłka za pobraniem
                        </dd>
                    </div>

                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Nawet 3000 zł na zakupy</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Z czasem możesz jeszcze więcej - Twój limit na
                            kolejne zakupy może wzrosnąć aż do 3000zł
                        </dd>
                    </div>

                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Prosta obsługa</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Błyskawiczne i bezpieczne płatności - kolejne
                            transakcje potwierdzasz tylko kodem SMS
                        </dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>

    <hr>

    <div class="bg-white">
        <div class="mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:grid lg:grid-cols-3 lg:gap-x-8 lg:py-24 lg:px-8">
            <div>
                <h2 class="text-lg font-semibold text-indigo-600">Płać do 45 dni</h2>
                <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900">Platforma Twisto</p>
                <p class="mt-4 text-lg text-gray-500">Szczegółowe informacje znajdziesz na stronie: <a
                    href="https://twisto.pl" class="font-bold">twisto.pl</a></p>

                <a href="https://twisto.pl" aria-label="Twisto homepage" class="h-16 m-12 flex justify-center">
                    <img src="https://twisto.pl/static/img/twisto-logo.svg?hash=f13aac3c" alt="" class="">
                </a>
            </div>


            <div class="mt-12 lg:col-span-2 lg:mt-0">
                <dl class="space-y-10 sm:grid sm:grid-flow-col sm:grid-cols-2 sm:grid-rows-3 sm:gap-x-6 sm:gap-y-10 sm:space-y-0 lg:gap-x-8">

                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Termin zapłaty</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Szykują się zakupy, a Tobie akurat zabrakło
                            pieniędzy? A może wolisz sprawdzić produkt, zanim za niego zapłacisz? Przesuń płatność za
                            dowolny zakup w sklepie internetowym lub stacjonarnym do 15. dnia kolejnego miesiąca. Za
                            darmo
                        </dd>
                    </div>

                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Wygodne raty</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Robisz zakupy za 200 zł lub więcej? Podziel
                            płatność na 3 miesięczne raty za 0 zł albo do 12 rat za opłatą.
                        </dd>
                    </div>

                    <div class="relative">
                        <dt>
                            <!-- Heroicon name: outline/check -->
                            <svg class="absolute h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                            </svg>
                            <p class="ml-9 text-lg font-medium leading-6 text-gray-900">Przesuń płatność</p>
                        </dt>
                        <dd class="mt-2 ml-9 text-base text-gray-500">Zapłać część rachunku, a resztę przesuń na
                            następny miesiąc jednym kliknięciem - w aplikacji lub koncie online. Sprawdź ile to kosztuje
                            i zdecyduj.
                        </dd>
                    </div>


                </dl>
            </div>
        </div>
    </div>


    <div class="mt-8 flex justify-center">
        <div class="inline-flex rounded-md shadow">
            <a href="https://uchowanca.pl/placepozniejesklep"
               class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-500 px-5 py-3 text-base font-medium text-white hover:bg-indigo-700">
                Zaczynamy zakupy!
            </a>
        </div>
    </div>

</template>

<script>
export default {
    name: "PayLater"
}
</script>

<style scoped>

</style>
